export default __webpack_public_path__ + "static/media/staircase.72488544.png";